import React, { useState, useEffect } from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import { AktualitaItem, fetchAktuality } from "../../lib/cms.ts";

const Aktuality: React.FC = () => {
  const [aktuality, setAktuality] = useState<AktualitaItem[]>([]);

  useEffect(() => {
    fetchAktuality(2).then(setAktuality).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#531d08]">
      <Helmet>
        <title>Aktuality | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Nejnovější informace z naší hospůdky. Zjistěte, co chystáme a co je nového."
        />

        {/* STRUCTURED DATA PRO AI & GOOGLE */}
        {aktuality.map((a, i) => (
          <script
            key={i}
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "NewsArticle",
                mainEntityOfPage: {
                  "@type": "WebPage",
                  "@id": "https://www.hospudkapodrablinu.cz/aktuality",
                },
                headline: a.nadpis,
                articleBody: a.text,
                datePublished: a.datum || undefined,
                image: a.obrazekUrl
                  ? [a.obrazekUrl]
                  : undefined,
                author: {
                  "@type": "Organization",
                  name: "Hospůdka pod Rablinů",
                },
                publisher: {
                  "@type": "Organization",
                  name: "Hospůdka pod Rablinů",
                  logo: {
                    "@type": "ImageObject",
                    url: "https://www.hospudkapodrablinu.cz/img/hospudka-pod-rablinu-logo.png",
                  },
                },
              }),
            }}
          />
        ))}
      </Helmet>

      {/* NAVBAR */}
      <Navbar />

      {/* NADPIS STRÁNKY */}
      {aktuality.length === 0 && (
        <section className="w-full py-12 md:py-20 text-center">
          <h1 className="font-serif text-3xl md:text-5xl xl:text-6xl font-light text-[#60260f]">
            AKTUALITY & INFORMACE
          </h1>
        </section>
      )}

      {/* OBSAH */}
      <section
        className={`flex flex-col gap-24 pb-24 ${aktuality.length > 0 ? "pt-12 md:pt-20" : ""}`}
      >
        {aktuality.map((a, i) => (
          <article
            key={i}
            className="max-w-5xl mx-auto px-4 text-center"
          >
            <h2 className="font-serif text-2xl md:text-4xl xl:text-5xl mb-6">
              {a.nadpis}
            </h2>

            <p className="text-sm md:text-base xl:text-lg leading-relaxed mb-6">
              {a.text}
            </p>

            <p className="text-xs md:text-sm underline mb-8">
              <strong>Datum akce:</strong> {a.datum || "neuvedeno"}
            </p>

            {a.obrazekUrl && (
              <img
                src={a.obrazekUrl}
                alt={a.nadpis}
                className="mx-auto rounded-xl w-full md:w-3/4 xl:w-2/3 shadow-lg"
              />
            )}
          </article>
        ))}
      </section>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default Aktuality;
